import { createApp } from 'vue';
import OpusToOggConverter from '@/Components/OpusToOggConverter.vue';
import '@styles/app.css';

createApp(OpusToOggConverter).mount('#opus-to-ogg-converter');
